module.exports = __webpack_public_path__ + "static/media/Banner-AlcoholLiquido.aef7fbae.jpg";